import React, { useEffect, useState, useRef } from "react";
import { Card, Table, Alert, Spinner, Dropdown, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
export default function ViewCommission(props) {
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 5;
  const activePag = useRef(0);
  var history = useHistory();
  const [searchData, setSearchData] = useState([]);
  const [onboardUser, setOnBoardUser] = useState([]);
  const [commissionID, setCommissionID] = useState('');
  const [onboardID, setOnBoardID] = useState('');
  const [vehicleName, setVehicleName] = useState('');
  const [spinner, setSpinner] = useState(true);
  const [update, setUpdate] = useState(false);
  const [show, setShow] = useState(false);
  const [commission, setCommission] = useState();
  const { id } = props.match.params;
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  function getData() {
    axios
      .get(
        `${Baseurl.baseurl}/onboarding/get-onboarding-by-id/${id}`
      )
      .then((res) => {
        setOnBoardID(res.data.onboarding._id)
        setSpinner(false);
        setOnBoardUser(res.data.onboarding.CommissionModel);
        setSearchData(res.data.onboarding.CommissionModel);
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData();
  }, []);
  function searchRider(value) {
    let filteredData = [];
    if(searchData){
      searchData.map((val) => {
        if ( val.VehicleType.toLowerCase().includes(value) ) {
          filteredData.push(val);
        }
      });
      setOnBoardUser(filteredData);  
    }
    
  }
  function deleteHandler(){
    const artical = {
      commissionModelID: commissionID,
    };
    axios
      .put(`${Baseurl.baseurl}/onboarding/remove-onboarding-commission/${onboardID}`, artical)
      .then(
        (response) =>
          {
           if(response.data.status)
             {
               swal("deleted", response.data.message, "success", {
                button: "Done",
                timer: 1000,
              })
              getData()
            }
              else
           {
             swal("Oops", response.data.message, "error", {
                button: "Try Again!",
                timer: 1000,
              })
            }
        setShow(false)
          }
      )
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  function updateHandler(){
    let comm=parseInt(commission)
    const artical = {
      commissionID: commissionID,
      VehicleCommission:comm
    };
    axios
      .put(`${Baseurl.baseurl}/onboarding/update-onboarding-commission`, artical)
      .then(
        (response) =>
          {
           if(response.data.status)
             {
               swal("Updated", response.data.message, "success", {
                button: "Done",
                timer: 1000,
              })
              getData()
            }
              else
           {
             swal("Oops", response.data.message, "error", {
                button: "Try Again!",
                timer: 1000,
              })
            }
        setShow(false)
          }
      )
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  return (
    <Card
      style={{
        color: "white",
        background:
          "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
      }}
    >
      <Modal
        size="md"
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        {update&&(
          <Modal.Header>
            <Modal.Title>Update Commission</Modal.Title>
          </Modal.Header>
        )}
        <Modal.Body>
        {update?(
          <div className="col-auto">
          <label>Commission</label>
          <div className="input-group mb-2">
            <input
              type="number"
              className="form-control"
              placeholder="in %"
              defaultValue={commission}
              onChange={(e) => {
                setCommission(e.target.value);
              }}
            />
          </div>
        </div>
        ):(
          <div className="row">
            <h4>Are you sure you want to delete </h4><h4 className="text-danger ml-2">{vehicleName}</h4>
          </div>
        )}
       
        </Modal.Body>
        <Modal.Footer>
        {update?(
           <button 
           onClick={()=>{
             updateHandler()
             }}
           className="btn btn-primary">Update</button>
        ):(
          <button 
          onClick={()=>{deleteHandler()}}
          className="btn btn-primary">Delete</button>
        )}
        
        </Modal.Footer>
      </Modal>
      <Card.Header>
       
        <div>
          <input
            type="text"
            className="form-control"
            placeholder="Search here..."
            onChange={(e) => {
              searchRider(e.target.value);
            }}
          />
        </div>
        <Link to='/partner'>
        <button className="btn btn-primary">Back</button>
        </Link>
      </Card.Header>
      <Card.Body>
        <div id="job_data" className="dataTables_wrapper ">
          {spinner ? (
            <div className="text-center">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <Table className="text-white" responsive>
              <thead>
                <tr>
                  <th>
                    <strong>SL NO.</strong>
                  </th>

                  <th>
                    <strong>VEHICLE NAME</strong>
                  </th>

                  <th>
                    <strong>COMMISSION</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {onboardUser &&
                  onboardUser.map((rider, key) => (
                    <tr key={rider.id}>
                      <td>{key + 1}</td>

                      <td>{rider.VehicleType}</td>
                      <td>{rider.VehicleCommission}</td>
                      <td>
                        <button 
                        onClick={() => {
                          setCommissionID(rider._id)
                          setCommission(rider.VehicleCommission)
                          setShow(true)
                          setUpdate(true)
                        }}
                        className="btn btn-primary">Update</button>
                        </td>
                        <td>
                        <button 
                        onClick={() => {
                          setVehicleName(rider.VehicleType)
                          setCommissionID(rider._id)
                          setShow(true)
                          setUpdate(false)
                        }}
                        className="btn btn-primary">Delete</button>
                        </td>
                      
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}

          {!onboardUser && (
            <Alert
              variant="success"
              className="alert-dismissible fade show text-center"
            >
              Zero Partners
            </Alert>
          )}
          <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
            <div className="dataTables_info text-white">
              Showing {activePag.current * sort + 1} to{" "}
              {data.length > (activePag.current + 1) * sort
                ? (activePag.current + 1) * sort
                : data.length}{" "}
              of {data.length} entries
            </div>
            <div
              className="dataTables_paginate paging_simple_numbers"
              id="example5_paginate"
            >
              <Link
                className="paginate_button previous disabled"
                onClick={() =>
                  activePag.current > 0 && onClick(activePag.current - 1)
                }
              >
                Previous
              </Link>
              <span>
                {paggination.map((number, i) => (
                  <Link
                    key={i}
                    className={`paginate_button  ${
                      activePag.current === i ? "current" : ""
                    } `}
                    onClick={() => onClick(i)}
                  >
                    {number}
                  </Link>
                ))}
              </span>
              <Link
                className="paginate_button next"
                onClick={() => {
                  activePag.current + 1 < paggination.length &&
                    onClick(activePag.current + 1);
                }}
              >
                Next
              </Link>
            </div>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
